export default __webpack_public_path__ + "static/media/752.fb6eee42.png";